import type { FunctionComponent } from "react";
import { CsvSliderMenuAdminPartial } from "../../../../partials/admin/menus/favourites/csv-slider-menu.admin.partials";

export const CsvSliderMenuAdminScreen: FunctionComponent = () => {
	return <CsvSliderMenuAdminPartial />;
};
